import type React from 'react'

interface ILightbulbIconProps {
  className?: string
  width?: number
  height?: number
  color?: string
  gradient?: boolean
}

export const LightbulbIcon: React.FC<ILightbulbIconProps> = ({
  className,
  width = 24,
  height = 24,
  color = '#FFCB00',
  gradient = false,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        {gradient && (
          <linearGradient
            id="lightbulb-gradient"
            x1="-3.81256"
            y1="11.9988"
            x2="23.2989"
            y2="11.9988"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.290054" stopColor="#A2397D" />
            <stop offset="1" stopColor="#6A5ACD" />
          </linearGradient>
        )}
      </defs>
      <path
        d="M16.8751 21.75C16.8751 22.0484 16.7566 22.3346 16.5456 22.5455C16.3346 22.7565 16.0485 22.875 15.7501 22.875H8.25013C7.95176 22.875 7.66561 22.7565 7.45463 22.5455C7.24365 22.3346 7.12513 22.0484 7.12513 21.75C7.12513 21.4517 7.24365 21.1655 7.45463 20.9546C7.66561 20.7436 7.95176 20.625 8.25013 20.625H15.7501C16.0485 20.625 16.3346 20.7436 16.5456 20.9546C16.7566 21.1655 16.8751 21.4517 16.8751 21.75ZM20.6251 9.75005C20.6285 11.0571 20.3333 12.3477 19.7618 13.5232C19.1904 14.6987 18.3579 15.7281 17.3279 16.5329C17.1884 16.6391 17.0751 16.7759 16.9966 16.9327C16.9182 17.0895 16.8766 17.2622 16.8751 17.4375V17.625C16.8751 18.1223 16.6776 18.5992 16.3259 18.9509C15.9743 19.3025 15.4974 19.5 15.0001 19.5H9.00013C8.50285 19.5 8.02593 19.3025 7.6743 18.9509C7.32267 18.5992 7.12513 18.1223 7.12513 17.625V17.4375C7.12492 17.2651 7.08508 17.095 7.00868 16.9404C6.93228 16.7858 6.82136 16.6509 6.6845 16.546C5.65735 15.7459 4.82562 14.7227 4.25228 13.5538C3.67893 12.3848 3.37898 11.1008 3.37513 9.7988C3.34981 5.12723 7.12513 1.23755 11.7929 1.12505C12.9429 1.09742 14.0868 1.30009 15.1572 1.72115C16.2277 2.14221 17.2031 2.77314 18.0261 3.57681C18.8491 4.38049 19.503 5.34066 19.9493 6.40084C20.3957 7.46101 20.6255 8.59975 20.6251 9.75005ZM18.3751 9.75005C18.3754 8.89969 18.2055 8.05788 17.8755 7.27417C17.5455 6.49047 17.062 5.7807 16.4536 5.18666C15.8451 4.59262 15.124 4.12631 14.3326 3.81519C13.5412 3.50406 12.6955 3.35441 11.8454 3.37505C8.39638 3.45755 5.60638 6.33286 5.62513 9.78567C5.62834 10.748 5.85029 11.6969 6.27419 12.5608C6.6981 13.4247 7.31286 14.1809 8.072 14.7722C8.45444 15.0674 8.7688 15.4415 8.99367 15.8691C9.21854 16.2967 9.34865 16.7677 9.37513 17.25H14.6345C14.6615 16.7667 14.7918 16.2948 15.0166 15.8661C15.2414 15.4374 15.5554 15.0618 15.9376 14.7647C16.6989 14.1697 17.3143 13.4085 17.7367 12.5395C18.1592 11.6704 18.3775 10.7163 18.3751 9.75005ZM16.4936 9.2513C16.394 8.40951 16.0612 7.61231 15.5326 6.94968C15.0039 6.28705 14.3006 5.78538 13.502 5.5013C13.2229 5.41009 12.9191 5.43165 12.6557 5.56137C12.3922 5.6911 12.1899 5.91869 12.092 6.19555C11.9941 6.47242 12.0083 6.77659 12.1316 7.04311C12.2549 7.30962 12.4776 7.51735 12.752 7.62192C13.1533 7.7626 13.5073 8.01275 13.7739 8.3441C14.0404 8.67545 14.209 9.07478 14.2604 9.49692C14.2933 9.79355 14.4426 10.065 14.6755 10.2515C14.7909 10.3439 14.9233 10.4126 15.0652 10.4538C15.2071 10.495 15.3558 10.5079 15.5026 10.4916C15.6495 10.4754 15.7917 10.4303 15.9212 10.3591C16.0507 10.2879 16.1649 10.1919 16.2572 10.0765C16.3496 9.96118 16.4183 9.82876 16.4595 9.68685C16.5007 9.54494 16.5136 9.3963 16.4973 9.24942L16.4936 9.2513Z"
        fill={gradient ? 'url(#lightbulb-gradient)' : color}
      />
    </svg>
  )
}

export default LightbulbIcon
